import React from 'react';

const LegalPage = ({
  variant = 'privacy',
  title,
  updated,
  publicUrl,
  showHeroImage = false,
  children,
}) => {
  const prefix = variant === 'terms' ? 'terms' : 'privacy';

  return (
    <div className={`${prefix}-page`}>
      <div
        className={`${prefix}-header`}
        style={showHeroImage ? {
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`,
        } : undefined}
      >
        <div className="container">
          <div className={variant === 'terms' ? undefined : 'privacy-text-container'}>
            <h1>{title}</h1>
            {updated && <p className={`${prefix}-updated`}>Last Updated: {updated}</p>}
            {publicUrl && (
              <p className="privacy-public-url">
                <a href={publicUrl} target="_blank" rel="noopener noreferrer">
                  View Public Document
                </a>
              </p>
            )}
          </div>
        </div>
      </div>

      <div className={`${prefix}-content`}>
        <div className="container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
